import { IconClipboardList, IconServer, IconUsers, type Icon } from '@tabler/icons-react';
import { typeGlyph } from '../components/TypeGlyph/typeGlyph.js';
import {
    AUDIT_ROUTE,
    CONFIGS_ROUTE,
    ENVIRONMENTS_ROUTE,
    GAMES_ROUTE,
    STUDIOS_ROUTE,
    USERS_ROUTE,
} from '../domain/routes.js';

/** The group a destination sits under — the sidebar's eyebrow and the header's first crumb. */
export type NavSection = 'Catalog' | 'Operations';
export type NavLink = { label: string; to: string; icon: Icon; section: NavSection };

export const navLinks: NavLink[] = [
    { label: 'Studios', to: STUDIOS_ROUTE, icon: typeGlyph('studio'), section: 'Catalog' },
    { label: 'Games', to: GAMES_ROUTE, icon: typeGlyph('game'), section: 'Catalog' },
    { label: 'Configs', to: CONFIGS_ROUTE, icon: typeGlyph('config'), section: 'Catalog' },
    { label: 'Environments', to: ENVIRONMENTS_ROUTE, icon: IconServer, section: 'Catalog' },
    { label: 'Audit log', to: AUDIT_ROUTE, icon: IconClipboardList, section: 'Operations' },
    { label: 'Users', to: USERS_ROUTE, icon: IconUsers, section: 'Operations' },
];
